import React, { useEffect } from 'react';
import './Notification.css';

const Notification = ({ title, message, type, onClose }) => {
  const titleClass = type === 'success' ? 'title-success' : 'title-error';

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); 

    return () => clearTimeout(timer); 
  }, [onClose]);

  return (
    <div className="notification-container">
      <div className={`notification-title ${type === 'success' ? 'title-success' : 'title-error'}`}>
        <span>{title}</span>
        <span className="close-btn" onClick={onClose}>&times;</span>
      </div>
      <div className="notification-message">
        {message}
      </div>
    </div>
  );

};

export default Notification;

